<script setup>
/*
 * Software stack the firm works with. Honest trust signal for a young firm —
 * shows competence with industry-standard tools without faking client logos.
 *
 * To replace with real client logos later, swap to `{ name, monogram }` pattern
 * and update the heading copy.
 */
const tools = [
    { name: 'Pohoda', label: 'POHODA' },
    { name: 'Money S3', label: 'MONEY S3' },
    { name: 'Flexi', label: 'FLEXI' },
    { name: 'ABRA', label: 'ABRA' },
    { name: 'FORM studio', label: 'FORM STUDIO' },
    { name: 'Fakturoid', label: 'FAKTUROID' },
]
</script>

<template>
    <section
        class="border-y border-zinc-100 bg-white py-14"
        aria-label="Účetní nástroje, se kterými pracujeme"
    >
        <div class="mx-auto max-w-7xl px-6 lg:px-10">
            <p class="text-center text-xs font-semibold tracking-[0.18em] text-zinc-500 uppercase">
                Pracujeme s nástroji jako
            </p>

            <ul class="mt-8 grid grid-cols-3 items-center gap-x-8 gap-y-6 md:grid-cols-6">
                <li
                    class="flex items-center justify-center"
                    v-for="tool in tools"
                    :key="tool.name"
                >
                    <span
                        class="text-base font-extrabold tracking-tight text-zinc-400 transition-colors hover:text-zinc-600 md:text-lg"
                        :title="tool.name"
                        :aria-label="tool.name"
                    >
                        {{ tool.label }}
                    </span>
                </li>
            </ul>
        </div>
    </section>
</template>
